import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IComponentSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { IFormTriggerActionButtonProps } from '.';

export const generate = (
  props?: Partial<IComponentSchema<IFormTriggerActionButtonProps>>
): IComponentSchema<IFormTriggerActionButtonProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.VOID,
    name: props?.name || id,
    title: props?.title || 'Form Action Trigger Button',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-component': ComponentType.FormTriggerActionButton,
    'x-component-props': {
      text: props?.['x-component-props']?.text || 'Submit',
      transformer: '{ modelInstanceId: $instance.id, payload: $form }',
      confirm: {
        ...(props?.['x-component-props']?.confirm || {}),
        show: props?.['x-component-props']?.confirm?.show || true,
      },
    },
    'x-component-props-config': {},
  };
};
